import { render } from "./AutomationKindDialog.vue?vue&type=template&id=9610351e&scoped=true&ts=true"
import script from "./AutomationKindDialog.vue?vue&type=script&lang=ts"
export * from "./AutomationKindDialog.vue?vue&type=script&lang=ts"

import "./AutomationKindDialog.vue?vue&type=style&index=0&id=9610351e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9610351e"]])

export default __exports__